import { createPortal } from "react-dom";

export function toast(msg, type="info"){
  const el = document.createElement("div");
  el.className = `toast ${type}`;
  el.textContent = msg;
  document.body.appendChild(el);
  setTimeout(()=> el.remove(), 2800);
}

export default function ToastStyles(){
  // os estilos estão no CSS global; este componente só existe
  // para garantir que o portal/estilos sejam carregados se quiser
  return createPortal(<></>, document.body);
}
